import { Injectable, OnChanges, OnInit } from '@angular/core';
import { ConfigurationOptions } from '../models';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class ConfigurationService implements OnChanges, OnInit {
    configurationObject: any;
    public onlineStatusChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public isOnline: boolean = true;
    public isOfflineData: boolean = false;
    public previlgeConfig:any = [];
    configOptions: ConfigurationOptions;
    private language: any;
    constructor(private http: HttpClient) {
      this.onlineStatusChange.subscribe((value) => {
        console.log('Connection status in LIb ' + value);
        this.isOnline = value;
      });

    }
    get languageModifier(): any {
      return this.language;
    }
    set languageModifier(languageObject: any) {
      this.language = languageObject;
    }
    ngOnInit(){
      console.log('config')
    }
      ngOnChanges() {
        console.log('service', this.configOptions);
    
      }
      getPrivileges(){
        this.previlgeConfig = this.configOptions.ReceivingPrivileges != '' ? JSON.parse(this.configOptions.ReceivingPrivileges): '';
      }
      previlegAuthenticated(PrevilgeKey: string): boolean {
        try {
          let isAuthenticatedPrevilege: boolean = false;
          this.getPrivileges();
          const getKey = 'Receiving';
        if (PrevilgeKey && PrevilgeKey !== null && PrevilgeKey !== undefined && this.previlgeConfig && this.previlgeConfig != '' && this.previlgeConfig.Receiving.length > 0) {
          const indexValue = this.previlgeConfig.Receiving.findIndex(x => x === PrevilgeKey);
          if (indexValue > -1) {
              isAuthenticatedPrevilege = true;
            }
        } else {
          console.log('Assign Invalid key check previlegeModule');
        }
        return isAuthenticatedPrevilege;
        } catch (error) {
          console.log('error occured MismatchModule', error);
        }
      }
}
